
<div class="tabs-container">
  <!-- <ion-row> -->
    <!-- <ion-col size class="pl-15 pr-0 pb-0"> -->
      <div>

        <mat-tab-group #tabGroup class="pr-10"
        (selectedTabChange)="tabTypeChanged($event)">
      
          <mat-tab label="offerAndAppoinment" *ngIf="(loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin' || loggedInUserRole == 'MD')">
          <ng-template mat-tab-label>
            <span style="display: contents;">
              <span class="material-icons mr-10">
                person
              </span>Offer And Appointment</span>
          </ng-template>
        </mat-tab>
        <mat-tab label="Probation"  *ngIf="(loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin' || loggedInUserRole == 'MD') || 
        (loggedInUserRole == 'HOD' && confirmationProbationWhomSetup == 'HOD')||
        (loggedInUserRole == 'Manager' && confirmationProbationWhomSetup == 'LINE_MANAGER')||
        ((checkLineManagerAndHodForReport.length > 0||checkLineManagerAndHodForReportForConfirmation.length>0) && confirmationProbationWhomSetup === 'LINE_MANAGER'&&loggedInUserRole==='HOD') ">
          <ng-template mat-tab-label>
            <span style="display: contents;">
              <span class="material-icons mr-10">
                ads_click
              </span>Probation</span>
          </ng-template>
        </mat-tab>
        <mat-tab label="ExitReport"
          >
          <ng-template mat-tab-label>
            <span style="display: contents;">
              <span class="material-icons mr-10">
                ads_click
              </span>Exit</span>
          </ng-template>
        </mat-tab>
      
        </mat-tab-group>

      
      
      </div>
    <!-- </ion-col>  -->
  <!-- </ion-row> -->

  <!------------------------------------------------------ offer And Appoinment ------------------------------------------------------->

  <div class="report-container">
  <div *ngIf="selectedTypeTabName==='offerAndAppoinment' && (loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin' || loggedInUserRole == 'MD')">
    <div class="pt-10 report-eoa-tabs">
      <div class="d-flex">
        <button type="button" (click)="onClickSubTab('EmployeeApplicationMaster')"
          [ngClass]="{'activeSubTaskTab' : selectedSubTab == 'EmployeeApplicationMaster'}" class="borderRadiusRight tabsBtn fs-14 fs_12ForMobile"><span
            class="displayContent">
            Employee Application Master</span></button>
  
            <button type="button" (click)="onClickSubTab('offerLetterMaster')"
            [ngClass]="{'activeSubTaskTab' : selectedSubTab == 'offerLetterMaster'}" class="tabsBtn fs-14 fs_12ForMobile"><span
              class="displayContent">
             Offer Letter Master</span></button>
        <button type="button"  [ngClass]="{'activeSubTaskTab' : selectedSubTab == 'appoinmentLetterMaster'}"
          class="borderRadiusLeft tabsBtn fs-14 fs_12ForMobile" (click)="onClickSubTab('appoinmentLetterMaster')"><span class="displayContent">
            Appointment Letter Master</span></button>
       
      </div>

    
    </div>
    </div>

<!------------------------------------------------------ offer And Appoinment ------------------------------------------------------->

<div class="offreletercontainer" *ngIf="selectedTypeTabName==='offerAndAppoinment'  &&(loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin' || loggedInUserRole == 'MD')">
  <div *ngIf="selectedSubTab=='EmployeeApplicationMaster' " >
    <app-elcm-employee-application-report></app-elcm-employee-application-report>
  </div>
     
  <div *ngIf="selectedSubTab =='offerLetterMaster'">
    <app-elcm-offer-letter-report></app-elcm-offer-letter-report>
  </div>
  
  <div *ngIf="selectedSubTab=='appoinmentLetterMaster'">
    <app-elcm-appoinment-letter-report></app-elcm-appoinment-letter-report>
  </div>
</div>

</div>


<!------------------------------------------------------ Probation  ------------------------------------------------------->
<!--  *ngIf="loggedInUserRole== 'HOD'|| loggedInUserRole=='Manager'|| selectedTypeTabName=='Probation'" -->
<div class="report-container-for-probation mt-20" *ngIf="(loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin' || loggedInUserRole == 'MD') || 
        (loggedInUserRole == 'HOD' && confirmationProbationWhomSetup == 'HOD')||
        (loggedInUserRole == 'Manager' && confirmationProbationWhomSetup == 'LINE_MANAGER')||
        ((checkLineManagerAndHodForReport.length > 0||checkLineManagerAndHodForReportForConfirmation.length>0) && confirmationProbationWhomSetup === 'LINE_MANAGER'&&loggedInUserRole==='HOD') ">

  <div class="probationReport" *ngIf="shouldShowProbationReport() && selectedTypeTabName !=='ExitReport'">
 
  

    <div class="cardBox p-10 m-20">


      <ion-row>
        <ion-col size>
          <div class="phi-flex-wrap-center phi-gap-12 phi-align-items-center">
          <mat-form-field class="mat-height40 mat-input-style w-100 max-w-220">
            <mat-icon matPrefix>search</mat-icon>
            <input matInput type="search" placeholder="Search"[(ngModel)]="searchTerm" (input)="filterEmployees()">
  
          </mat-form-field>
        <!-- </ion-col>
        <ion-col size="2" class="mt-20"> -->
          <!-- <div class="formLabelRegularfs16  mb-5">
            Select Dept
          </div> -->
  
        <div class="w-100 max-w-220">
          <ng-multiselect-dropdown *ngIf="getDeptList.length>0" [placeholder]="'Select Dept'" [settings]="dropdownSettings"
          [data]="getDeptList" [(ngModel)]="selectedDep" (onSelect)="onSelectDepartment()"
          (onDeSelect)="onDeSelectDepartment()" (onSelectAll)="selectAllDepartment($event)"
          (onDeSelectAll)="onDeSelectAllDepartment()">
          </ng-multiselect-dropdown>
        </div>
        </div>
        </ion-col>

        <ion-col size="auto">
          <div class="phi-flex-wrap-center phi-gap-12">
          <label class="phi-flex phi-gap-6 phi-align-items-center">
            <ion-label class="fs-14 fs_12ForMobile font_regular black_color">Show</ion-label>
            <mat-form-field class="w70px mat-height40 mat-input-style">
              <mat-select placeholder="Select" placeholder="Select" (selectionChange)="DislaySelectedRecord($event)"[value]="25">
                <mat-option [value]="1">1</mat-option>
                <mat-option [value]="25">25</mat-option>
                <mat-option [value]="50">50</mat-option>
                <mat-option [value]="75">75</mat-option>
                <mat-option [value]="100">100</mat-option>
              </mat-select>
            </mat-form-field>
            <ion-label class="fs-14 fs_12ForMobile font_regular black_color">entries</ion-label>
          </label>
          <div>
              <span class="icon-download fs-20 material-icons" (click)=" downloadCSV()">download</span>
            </div>
            </div>
        </ion-col>
  
  
        <!-- <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3">
          <div class="d-flex justify-content-flex-end ">
            <div class="d-flex" style="margin-right: 15px; margin-top: 10px;cursor: pointer;" (click)=" downloadCSV()">
              <span class="ml-5 mr-5 icon-download fs-20 material-icons">download</span>
            </div>
          </div>
        </ion-col> -->
      </ion-row>



      <div class="pt-10">
        <ion-row>
          <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
            <div class="table-container">
              <table>
                <thead>
                  <tr>
  
                    <th *ngFor="let item of OfferAndAppointmentTableHeader" class="fs-14 fs_12ForMobile font_bold cl-black">
                      <div class="p-5 verticle-center justify-content-space-between icon-style" stye="width:80px">
                        {{ item?.label }}
  
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let employee of employeesProbationDetails; let i = index">
                    <!-- Sr. No -->
                    <td>{{ i + 1 }}</td>
                    <td>{{ employee.empCode }}</td>
                    <td>{{ employee.empName }}</td>
                    <td>{{ employee.empDept }}</td>
                    <td>{{ employee.band}}</td>
                    <td>{{ employee.grade }}</td>
                    <td>{{ employee.doj | date: 'dd-MM-yyyy' }}</td>
  
  
                    <td>{{ employee.dateOfConfirmation | date: 'dd-MM-yyyy' }}</td>
                    <td>
                      {{employee.probationStatus}}
                    </td>
  
                    <td> {{employee.probationExtensionByDay}}</td>
                    <td>
                      <textarea rows="2" cols="4" class="edittextarea" [(ngModel)]="employee.reasonForExtension"
                        maxlength="255"(ngModelChange)="getprobationData(employee)" [ngModelOptions]="{standalone: true}" readonly></textarea>
                    </td> 
                   <td (click)="employee.changesPostConfirmation=='Change_Needed'?onClickOpenChangeNeededPopup(employee.userId,'ReportTab'):''"
                   [ngStyle]="employee.changesPostConfirmation === 'Change_Needed' ? 
             {'color': 'orange', 'text-decoration': 'underline', 'cursor': 'pointer'} : {}"> 
                      <!-- <mat-form-field class="w-90 mat-height40 mat-input-style">
                        <mat-select placeholder="select probation  "(ngModelChange)="getprobationData(employee)" [(ngModel)]="employee.changesPostConfirmation"
                         [disabled]="employee.probationStatus=='Extension'">
                          <mat-option [value]="'No_Change'">
                            No Change
                          </mat-option>
                          <mat-option [value]="'Change_Needed'" (click)="onClickOpenChangeNeededPopup(employee.userId,'ReportTab')">
                            Change Needed
                          </mat-option>
  
                        </mat-select>
                      </mat-form-field> -->
                      {{employee.changesPostConfirmation}}
                    
                    </td>
                  
                  </tr>
                </tbody>
              </table>
            </div>
          </ion-col>
        </ion-row>
      </div>
    </div>
     
  
   </div>
  
  
</div>

<!------------------------------------------------------ Probation  ------------------------------------------------------->

<!-- -----------------------------------------------------------Exit---------------------------------------------------- -->

 <div *ngIf=" selectedTypeTabName === 'ExitReport' ||loggedInUserRole=='Employee'">
 <div>

   <app-elcm-exit [getTabName]="'ExitReport'"></app-elcm-exit>
 </div>
</div>

  <ng-container *ngIf="
            (loggedInUserRole === 'Manager' && confirmationProbationWhomSetup === 'HOD') ||
            (loggedInUserRole === 'HOD' && confirmationProbationWhomSetup === 'LINE_MANAGER')&&
            ((checkLineManagerAndHodForReport?.length || 0) === 0 && (checkLineManagerAndHodForReportForConfirmation?.length || 0) === 0)
          ">

   <app-elcm-exit [getTabName]="'ExitReport'"></app-elcm-exit>
    </ng-container>

<!-- <div
 class="p-10"
 *ngIf="
(((loggedInUserRole=='HOD'&& confirmationProbationWhomSetup=='LINE_MANAGER')||(loggedInUserRole=='Manager'&& confirmationProbationWhomSetup=='HOD'))||( selectedTypeTabName=='offerAndAppoinment')
     &&(checkLineManagerAndHodForReport.length == 0 && checkLineManagerAndHodForReportForConfirmation.length==0) )">
 <div>
 
   <app-elcm-exit [getTabName]="'ExitReport'"></app-elcm-exit>
 </div> 
</div> -->


</div>